import React from 'react';
import { X } from 'lucide-react';
import PropTypes from 'prop-types';
import Button from 'tailwind-components/Button/Button';
import {
  partners,
  rateQuoteDetail,
  RATE_QUOTE_LOGO_URL
} from '../data/rateQuoteStaticContent';

function CheckIcon() {
  return (
    <svg
      className='size-5 shrink-0 text-secondary-darkest mt-0.5'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <path
        d='M20 6L9 17l-5-5'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default function RateQuoteDetailPanel({ onApplyNow, onBackToList }) {
  const rq = partners.rateQuote;
  const copy = rateQuoteDetail;

  return (
    <div data-tour='leads-rate-quote-panel' className='rounded-xl overflow-hidden border border-grey-lighter bg-white shadow-sm'>
      <div className='flex flex-row items-start gap-4 px-6 py-6 bg-[linear-gradient(90deg,var(--color-primary-darkened),var(--color-primary-emphasis-light))] text-white'>
        <div className='flex gap-4 flex-1 min-w-0 items-start'>
          <img
            src={RATE_QUOTE_LOGO_URL}
            alt=''
            width={72}
            height={72}
            className='size-[90px] shrink-0 rounded-full border-[3px] border-white/90 bg-white object-contain p-2'
            decoding='async'
          />
          <div className='flex flex-col gap-2 min-w-0 pt-0.5'>
            <h2 className='text-2xl md:text-3xl font-bold m-0 leading-tight text-white'>
              {rq.label}
            </h2>
            <p className='text-white/95 text-sm md:text-base mt-1 max-w-2xl m-0 leading-snug'>
              {rq.tagline}
            </p>
          </div>
        </div>
        <Button
          variant='transparent'
          type='button'
          onClick={onBackToList}
          aria-label='Close partner details'
          icon={<X className='size-[22px]' strokeWidth={2.25} aria-hidden />}
          className='shrink-0 -mr-1 -mt-1 text-white! hover:bg-white/15! border-transparent focus-visible:ring-2 focus-visible:ring-white/80 focus-visible:ring-offset-0'
        />
      </div>

      <div className='p-6 grid grid-cols-1 lg:grid-cols-3 gap-8'>
        <div className='lg:col-span-2 space-y-6'>
          <div>
            <h3 className='text-lg font-bold text-primary-darkened mb-3'>
              {copy.aboutHeading}
            </h3>
            <div className='space-y-3 text-black text-[length:--font-size-body] leading-relaxed'>
              {copy.paragraphs.map((p, i) => (
                <p key={`rq-about-${i}`}>{p}</p>
              ))}
            </div>
          </div>

          <div>
            <h3 className='text-lg font-bold text-primary-darkened mb-3'>
              {copy.fitHeading}
            </h3>
            <ul className='space-y-2'>
              {copy.fitBullets.map(item => (
                <li key={item} className='flex gap-2 items-start'>
                  <CheckIcon />
                  <span className='text-black'>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className='lg:col-span-1'>
          <div className='rounded-xl border border-grey-lighter bg-grey-lightest p-5 h-full flex flex-col'>
            <h3 className='md:text-3xl text-2xl font-bold m-0 leading-none text-black md:mb-6 mb-4'>
              {copy.applyCard.title}
            </h3>
            <p className='text-grey text-base md:text-lg m-0 leading-none mb-4 flex-1'>
              {copy.applyCard.description}
            </p>

            <div data-tour='leads-apply-now'>
              <Button
                type='button'
                text={copy.applyCard.buttonLabel}
                variant='primary'
                fill
                rounded='medium'
                onClick={onApplyNow}
                className='w-full justify-center mb-4'
              />
            </div>
            <p className='text-grey text-sm m-0 leading-snug italic'>
              {copy.applyCard.disclaimer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

RateQuoteDetailPanel.propTypes = {
  onApplyNow: PropTypes.func.isRequired,
  onBackToList: PropTypes.func.isRequired
};
